let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("kDs7y")).then(() => parcelRequire('b4NXj'));